"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * MetaTag Helper class.  Creates an array of tags for React-Helmet to inject in to the page.
 * react-isomorphic-render injects meta, link, and title tags in to the head on the server side.
 * It does not inject script tags. See:
 * https://github.com/catamphetamine/react-website/blob/11/source/page-server/html.js#L57
 */
var MetaTags = /*#__PURE__*/function () {
  function MetaTags() {
    _classCallCheck(this, MetaTags);

    this.tags = [];
  }

  _createClass(MetaTags, [{
    key: "push",
    value: function push(meta) {
      if (meta.content) {
        this.tags.push(meta);
      }

      return this;
    }
  }, {
    key: "pushAll",
    value: function pushAll(metaArray) {
      _lodash["default"].each(metaArray, this.push.bind(this));

      return this;
    }
  }, {
    key: "name",
    value: function name(_name, content) {
      return this.push({
        name: _name,
        content: content
      });
    }
  }, {
    key: "property",
    value: function property(_property, content) {
      return this.push({
        property: _property,
        content: content
      });
    }
  }, {
    key: "twitter",
    value: function twitter(name, content) {
      return this.name("twitter:".concat(name), content);
    }
  }, {
    key: "openGraph",
    value: function openGraph(name, content) {
      return this.property("og:".concat(name), content);
    } // Deprecated - Facebook now reads OpenGraph metadata tags

  }, {
    key: "facebook",
    value: function facebook(name, content) {
      return this.property("fb:".concat(name), content);
    } // Deprecated - Pinterest now reads (slightly non-standard) OpenGraph metadata tags

  }, {
    key: "pinterest",
    value: function pinterest(name, content) {
      return this.name("p:".concat(name), content);
    } // The following helpers are designed to support the Page Metadata content type in Contentful

  }, {
    key: "title",
    value: function title(value) {
      return this.twitter('title', value).openGraph('title', value);
    }
  }, {
    key: "description",
    value: function description(value) {
      return this.name('description', value).twitter('description', value).openGraph('description', value);
    }
  }, {
    key: "image",
    value: function image(value) {
      return this.twitter('image', value).openGraph('image', value);
    }
  }]);

  return MetaTags;
}();

exports["default"] = MetaTags;